import { render } from "./PageResult.vue?vue&type=template&id=7c7de9ba&ts=true"
import script from "./PageResult.vue?vue&type=script&lang=ts"
export * from "./PageResult.vue?vue&type=script&lang=ts"

import "./PageResult.vue?vue&type=style&index=0&id=7c7de9ba&lang=scss"

import exportComponent from "D:\\Users\\asato\\Documents\\GitHub\\suite_totalling_web\\totalling_web\\src\\html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__